import React, {Component} from 'react';
import {authService} from "../../../auth";
import {connect} from "react-redux";
import {Scrollbars} from 'react-custom-scrollbars';
import mappingUtils from "../../../project/component/commons/utils/mappingUtils";

class UnAuthEducationPopUp extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage()
        }
    }

    render() {
        return (
            <div id="educationViewpop" className="modal fade dgpopup reqendorse" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="profcolwidget">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>
                                <div className="profcolwidgetdesc">
                                    <h4>Education</h4>
                                    <Scrollbars
                                        className={'profcolwidgetwrap'}
                                        autoHide
                                        autoHeight
                                        autoHeightMin={0}
                                        autoHeightMax={325}
                                        universal={true}
                                        renderTrackHorizontal={props => <div {...props} className="track-horizontal"/>}
                                        renderTrackVertical={props => <div {...props} className="track-vertical"/>}
                                    >
                                        <div className="profeducat">
                                            <ul>
                                                {this.props.educationsList &&  this.props.educationsList.map((data, index) => {
                                                    return <li>
                                                        <figure className="complogo"><img
                                                            src="https://cdn.dscovr.com/images/educ1.webp" onError={(e)=>{e.target.onerror = null; e.target.src="https://cdn.dscovr.com/images/educ1.png"}} alt=""/></figure>
                                                        <div>
                                                            <h5>{data.institution}</h5>
                                                            <p>{data.specialisations}</p>
                                                            <span>{new Date(data.startTime).toLocaleDateString('en-GB', {
                                                                day: '2-digit', month: 'short', year: 'numeric'
                                                            }).replace(/ /g, '-')} to {mappingUtils.getEndDateCustomForExperience(data.endTime)}</span>
                                                        </div>
                                                    </li>
                                                })}

                                            </ul>
                                        </div>
                                    </Scrollbars>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




export default UnAuthEducationPopUp;
